import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export const OnlineCourses = () => {
  // Add dark mode state
  const [darkMode, setDarkMode] = useState(() => {
    // Check localStorage for saved preference, default to dark mode
    const savedMode = localStorage.getItem('studentDashboardTheme');
    return savedMode === 'dark' || !savedMode; // Default to dark mode if not set
  });
  // Listen for theme changes
  useEffect(() => {
    const handleThemeChange = event => {
      setDarkMode(event.detail.darkMode);
    };
    window.addEventListener('themeChange', handleThemeChange);
    return () => {
      window.removeEventListener('themeChange', handleThemeChange);
    };
  }, []);
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Define text color classes based on dark mode
  const textColorClass = darkMode ? 'text-white' : 'text-gray-800';
  const subtextColorClass = darkMode ? 'text-gray-300' : 'text-gray-600';
  const sectionBgClass = darkMode ? 'bg-white/5' : 'bg-white';
  const borderClass = darkMode ? 'border-white/10' : 'border-gray-200';
  return <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-5424">
      {/* Header */}
      <div className="mb-12" data-id="element-5425">
        <h1 className={`text-3xl md:text-4xl font-bold ${textColorClass} mb-3`} data-id="element-5426">
          Courses — Coming Soon
        </h1>
        <p className={`text-lg ${subtextColorClass}`} data-id="element-5427">
          Maestro Connect is preparing a dedicated courses section focused on
          high-quality music education.
        </p>
        <p className={`text-lg ${subtextColorClass} mt-2`} data-id="element-5428">
          This area will feature structured courses created by experienced
          musicians and educators, covering a wide range of topics across
          instruments, theory, and the music industry.
        </p>
      </div>

      {/* What This Section Will Offer */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5429">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5430">
          What This Section Will Offer
        </h2>
        <ul className={`space-y-3 ${subtextColorClass}`} data-id="element-5431">
          <li className="flex items-start" data-id="element-5432">
            <span className="mr-3" data-id="element-5433">•</span>
            <span data-id="element-5434">
              Instrument-focused courses (piano, guitar, violin, drums, and
              more)
            </span>
          </li>
          <li className="flex items-start" data-id="element-5435">
            <span className="mr-3" data-id="element-5436">•</span>
            <span data-id="element-5437">Music theory, harmony, and composition</span>
          </li>
          <li className="flex items-start" data-id="element-5438">
            <span className="mr-3" data-id="element-5439">•</span>
            <span data-id="element-5440">Music business, publishing, and career education</span>
          </li>
          <li className="flex items-start" data-id="element-5441">
            <span className="mr-3" data-id="element-5442">•</span>
            <span data-id="element-5443">
              Courses created by professional educators and working musicians
            </span>
          </li>
        </ul>
      </section>

      {/* How Courses Will Be Selected */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5444">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5445">
          How Courses Will Be Selected
        </h2>
        <p className={`${subtextColorClass} mb-4`} data-id="element-5446">
          Our goal is quality and credibility.
        </p>
        <p className={`${subtextColorClass} mb-3`} data-id="element-5447">Courses may include:</p>
        <ul className={`space-y-3 ${subtextColorClass} mb-4`} data-id="element-5448">
          <li className="flex items-start" data-id="element-5449">
            <span className="mr-3" data-id="element-5450">•</span>
            <span data-id="element-5451">
              Original courses created specifically for Maestro Connect
            </span>
          </li>
          <li className="flex items-start" data-id="element-5452">
            <span className="mr-3" data-id="element-5453">•</span>
            <span data-id="element-5454">Collaborations with established educators and creators</span>
          </li>
          <li className="flex items-start" data-id="element-5455">
            <span className="mr-3" data-id="element-5456">•</span>
            <span data-id="element-5457">
              Carefully selected third-party educational content where
              appropriate
            </span>
          </li>
        </ul>
        <p className={`${subtextColorClass}`} data-id="element-5458">
          Each course will be reviewed to ensure it provides clear educational
          value and practical learning outcomes.
        </p>
      </section>

      {/* Status */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} mb-8`} data-id="element-5459">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5460">Status</h2>
        <p className={`${subtextColorClass}`} data-id="element-5461">
          This section is currently under development and will launch after the
          core platform release. Courses will be added gradually.
        </p>
      </section>

      {/* Get Notified */}
      <section className={`${sectionBgClass} rounded-xl p-8 border ${borderClass} text-center`} data-id="element-5462">
        <h2 className={`text-2xl font-bold ${textColorClass} mb-4`} data-id="element-5463">
          Get Notified
        </h2>
        <p className={`${subtextColorClass} mb-6`} data-id="element-5464">
          Join the waitlist to be notified when courses become available.
        </p>
        <Link to="/" className="inline-block bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-8 rounded-lg transition-colors" data-id="element-5465">
          Join the Waitlist
        </Link>
      </section>
    </div>;
};